import { render, staticRenderFns } from "./ReferenceCheckLifecycle.vue?vue&type=template&id=5f84a352"
import script from "./ReferenceCheckLifecycle.vue?vue&type=script&lang=js"
export * from "./ReferenceCheckLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports